import React from 'react';
import { SearchIcon, SendIcon, ShareIcon, TrendingUpIcon, UsersIcon, MailIcon, CheckCircleIcon, BotIcon } from 'lucide-react';
import { StatCard } from './ui/StatCard';
import { ModuleCard } from './ui/ModuleCard';
interface DashboardProps {
  setActiveModule: (module: string) => void;
}
export const Dashboard = ({
  setActiveModule
}: DashboardProps) => {
  const stats = [{
    title: 'Identifizierte Leads',
    value: '1,243',
    change: '+12%',
    positive: true,
    icon: <UsersIcon size={20} className="text-blue-500" data-id="element-29" />
  }, {
    title: 'Offene Kampagnen',
    value: '8',
    change: '+3',
    positive: true,
    icon: <MailIcon size={20} className="text-green-500" data-id="element-30" />
  }, {
    title: 'Empfehlungen',
    value: '64',
    change: '+24%',
    positive: true,
    icon: <ShareIcon size={20} className="text-orange-500" data-id="element-31" />
  }, {
    title: 'Chatbot Konversionen',
    value: '38%',
    change: '+5%',
    positive: true,
    icon: <BotIcon size={24} data-id="element-32" />
  }];
  const modules = [{
    id: 'leadscout',
    title: 'LeadScout',
    description: 'Identifizieren Sie Ihre idealen B2B-Kunden mit datengestützter Analyse',
    icon: <SearchIcon size={24} data-id="element-33" />,
    color: 'bg-blue-500',
    actions: ['Intelligent Customer Profile erstellen', 'Leads exportieren']
  }, {
    id: 'smartreach',
    title: 'SmartReach',
    description: 'Personalisierte Kampagnen für maximale Conversion-Raten',
    icon: <SendIcon size={24} data-id="element-34" />,
    color: 'bg-green-500',
    actions: ['Neue Kampagne', 'Berichte']
  }, {
    id: 'referrocket',
    title: 'ReferRocket',
    description: 'Empfehlungsmarketing & Kundenwerben-Kunden Programme',
    icon: <ShareIcon size={24} data-id="element-35" />,
    color: 'bg-orange-500',
    actions: ['Programm erstellen', 'Empfehlungen']
  }, {
    id: 'conversai',
    title: 'ConversAI',
    description: 'KI-gestützte Automatisierung & Chatbot-Flows',
    icon: <BotIcon size={24} data-id="element-36" />,
    color: 'bg-purple-500',
    actions: ['Bot erstellen', 'Performance']
  }];
  return <div className="space-y-6" data-id="element-37">
      <div className="flex items-center justify-between" data-id="element-38">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-39">Übersicht</h2>
        <div className="flex items-center space-x-2" data-id="element-40">
          <span className="text-sm text-gray-500" data-id="element-41">Letzte 30 Tage</span>
          <button className="text-blue-500 text-sm font-medium hover:text-blue-600" data-id="element-42">
            Ändern
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-43">
        {stats.map((stat, index) => <StatCard key={index} {...stat} data-id="element-44" />)}
      </div>
      <div className="flex items-center justify-between pt-4" data-id="element-45">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-46">Module</h2>
        <button className="flex items-center text-blue-500 text-sm font-medium hover:text-blue-600" data-id="element-47">
          <TrendingUpIcon size={16} className="mr-1" data-id="element-48" />
          Leistung anzeigen
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-49">
        {modules.map(module => <ModuleCard key={module.id} {...module} onClick={() => setActiveModule(module.id)} data-id="element-50" />)}
      </div>
      <div className="bg-white rounded-lg shadow p-5 mt-6" data-id="element-51">
        <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-52">
          Neueste Aktivitäten
        </h2>
        <div className="space-y-4" data-id="element-53">
          {[1, 2, 3].map(item => <div key={item} className="flex items-start p-3 border-b border-gray-100 last:border-0" data-id="element-54">
              <div className="p-2 rounded-full bg-green-100 mr-3" data-id="element-55">
                <CheckCircleIcon size={16} className="text-green-500" data-id="element-56" />
              </div>
              <div data-id="element-57">
                <p className="text-sm text-gray-800" data-id="element-58">
                  <span className="font-medium" data-id="element-59">Smart Tech GmbH</span> hat auf
                  Ihre Kampagne reagiert
                </p>
                <p className="text-xs text-gray-500" data-id="element-60">Vor 2 Stunden</p>
              </div>
            </div>)}
        </div>
        <div className="mt-4 text-center" data-id="element-61">
          <button className="text-blue-500 text-sm font-medium hover:text-blue-600" data-id="element-62">
            Alle Aktivitäten anzeigen
          </button>
        </div>
      </div>
    </div>;
};